<template>
  <v-container fill-height fluid>
    <v-overlay :absolute="false" :value="!iframe.loaded">
      <v-alert>CARREGANDO &nbsp;&nbsp; <v-progress-circular indeterminate></v-progress-circular></v-alert>
    </v-overlay>
    <v-row align="center" justify="center">
      <v-col cols="12">
          <iframe :src="iframe.src" :width="iframe.width" :height="iframe.height" frameborder="0" ref="frameGrad"
            v-show="iframe.loaded" @load="loaded"></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  export default {
      components: {
          MaterialCard: () => import('../components/material/Card'),
          MaterialStatsCard: () => import('../components/material/StatsCard')
      },
      data: () => ({
          iframe: {
              src: 'https://datastudio.google.com/embed/reporting/39911994-569d-4281-b96b-572b967c9aec/page/p_p60tr7w7tc',
              loaded: false,
              height: null,
              width: '100%',
              originalWidth: 1800,
              originalHeight: 4030,
              autoResize: {
                  active: true,
                  timeout: 700,
                  timer: null
              },
          },
      }),
      mounted() {

      },
      beforeDestroy() {
          if(this.iframe.autoResize.timer) {
              clearInterval(this.iframe.autoResize.timer);
          }
      },
      methods: {
          loaded: function(){
              if(this.iframe.autoResize.active) {
                  this.iFrameResize();
                  this.iframe.autoResize.timer =
                      setInterval(this.iFrameResize, this.iframe.autoResize.timeout);
              }

              setTimeout(() => { this.iframe.loaded = true }, 1000); // delay
          },

          iFrameResize() {
              if(!this.$refs.frameGrad) {
                  return;
              }

              let parentWidth = this.$refs.frameGrad.parentElement.clientWidth;
              let ratio = this.iframe.originalHeight / this.iframe.originalWidth;
                // console.log(ratio);
                // console.log(parentWidth);
                // console.log(parseInt(ratio * parentWidth));
              this.iframe.height = parseInt(ratio * parentWidth) + 'px';
              this.iframe.width = '100%';
          }
      }
  }
</script>

<style lang="scss">
  .tim-note {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    margin-left: 20px;
    width: 260px;
  }
</style>
